var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('clickable',{staticClass:"v-iconbutton",class:{ loading: _vm.loading, disabled: _vm.disabled }},[_c('button',{attrs:{"disabled":{ disabled: 'disabled' }}},[_c('i',{class:_vm.iconName})])])}
var staticRenderFns = []

export { render, staticRenderFns }